import { ShieldAlert } from "lucide-react";

export const RequirePermission = ({ children, permission, user }) => {
  const hasAccess = !permission || user?.permissions?.includes(permission);
  if (hasAccess) {
    return children;
  }
  return (
    <div className="space-y-6" data-testid="permission-access-denied">
      <section>
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-zinc-500">Restricted</p>
        <h1 className="mt-2 text-4xl font-semibold text-zinc-900">Access restricted</h1>
      </section>
      <div className="panel-surface flex items-start gap-4 rounded-[32px] px-6 py-8" data-testid="permission-access-denied-card">
        <div className="rounded-2xl bg-amber-50 p-3 text-amber-700"><ShieldAlert className="h-5 w-5" /></div>
        <div>
          <p className="text-lg font-semibold text-zinc-900">Your account doesn't have access to this section.</p>
          <p className="mt-1 text-sm text-zinc-500">Ask an Admin to grant you access from Users &rarr; Access permissions.</p>
        </div>
      </div>
    </div>
  );
};
